import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { useGetBulletinNoDropdownListQuery } from '../../api/endpoints/serviceBulletinReport';
import { useLanguage } from '../../contexts/LanguageContext';

const BulletinNoDropdown = ({ 
    value, 
    onChange, 
    className = '', 
    disabled = false,
    placeholder
}) => {
    const { th,getCurrentLanguageId } = useLanguage();
    const [searchText, setSearchText] = useState('');
    const [filterValue, setFilterValue] = useState('');
    const debounceTimerRef = useRef(null);

    const { data: bulletinList = [], isLoading } = useGetBulletinNoDropdownListQuery({
        RowCount: 100,
        SearchText: searchText,
        LanguageId: getCurrentLanguageId()
    });

    const bulletinOptions = useMemo(() => {
        return bulletinList.map((bulletin) => ({
            label: bulletin.bulletinNo,
            name: bulletin.bulletinName,
            value: bulletin.bulletinNo,
        }));
    }, [bulletinList]);

  const itemTemplate = (option) => (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ fontWeight: 600, fontSize: '0.95rem' }}>{option.label}</span>
        <span style={{ fontSize: '0.8rem', color: 'var(--text-color-secondary)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: '250px', lineHeight: '1.2' }}>
            {option.name}
        </span>
    </div>
);
    const valueTemplate = (option) => {
        if (!option) return <span>{placeholder || th('common.search')}</span>;
        return <span>{option.label}</span>;
    };

    const handleFilterInputChange = (inputValue) => {
        setFilterValue(inputValue);

        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }

        debounceTimerRef.current = setTimeout(() => {
            setSearchText(inputValue);
        }, 500);
    };

    const filterTemplate = () => (
        <div className="p-dropdown-filter-container">
            <InputText
                value={filterValue}
                onChange={(e) => handleFilterInputChange(e.target.value)}
                className="p-dropdown-filter w-full"
                placeholder={th('common.search')}
                autoFocus
                type="text"
            />
            <span className="p-dropdown-filter-icon pi pi-search" />
        </div>
    );

    const handleChange = (e) => {
        onChange(e.value);
    };

    const handleShow = () => {
        setFilterValue('');
        setSearchText('');
        
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }
    };

    const handleHide = () => {
        setFilterValue('');
        setSearchText('');
        
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }
    };

    useEffect(() => {
        return () => {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, []);

    return (
        <Dropdown
            value={value}
            options={bulletinOptions}
            onChange={handleChange}
            onShow={handleShow}
            onHide={handleHide}
            className={className}
            placeholder={placeholder || th('common.search')}
            loading={isLoading}
            disabled={disabled}
            filter
            filterTemplate={filterTemplate}
            itemTemplate={itemTemplate}
            valueTemplate={valueTemplate}
            showClear
        />
    );
};

export default BulletinNoDropdown;